import React, { Component } from "react";
import "./logisticAlatmTool.module.scss";
import AlarmDayButton from "./AlarmDayButton";
import daysWeekEnum from "./LogisticDaysWeekService";

class AlarmDaysPanel extends Component {
  getAlarmDayButton(day, isCheck) {
    const { dayClickHandler = () => {} } = this.props;

    return <AlarmDayButton key={day.value + "" + isCheck} day={day.value} isCheck={isCheck} title={day.title} dayClick={dayClickHandler} />;
  }

  render() {
    const { dayCheked } = this.props;

    return [
      this.getAlarmDayButton(daysWeekEnum.MON, dayCheked.MON),
      this.getAlarmDayButton(daysWeekEnum.TUE, dayCheked.TUE),
      this.getAlarmDayButton(daysWeekEnum.WED, dayCheked.WED),
      this.getAlarmDayButton(daysWeekEnum.THU, dayCheked.THU),
      this.getAlarmDayButton(daysWeekEnum.FRI, dayCheked.FRI),
      this.getAlarmDayButton(daysWeekEnum.SAT, dayCheked.SAT),
      this.getAlarmDayButton(daysWeekEnum.SUN, dayCheked.SUN),
    ];
  }
}

export default React.memo(AlarmDaysPanel);
